import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";

export const useOrderedSiteIdsByStageId = (stageId: string) => {
  const { orderedSiteIdsByStageId } = useSnapshot(sitesPipelineStore);

  return (orderedSiteIdsByStageId[stageId] as string[]) ?? null;
};
